import IDOM from "./IDOM";
import SystemConfig, {CONFIG_PARAMS} from "../system/SystemConfig";
import IUIMessages from "./messages/IUIMessages";
import {isIOS} from "../device/device";
import userActionInstance, {ACTION_EVENTS} from "./UserAction";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import BgLayer from "./components/BgLayer";
import Wallet from "../wallet/Wallet";
import IGame from "../game/IGame";
import AjaxLoading from "./components/AjaxLoading";
import AjaxLoadingNew from "./components/AjaxLoadingNew";
import {initDOM} from "./shared/domInit";

export const BASE_ELEMENT_IDS = {

    "BUTTON_SPIN": "mxButtonSpin",
    "BUTTON_SPIN_AUTOSTART": "mxButtonSpinAutostart",
    "BUTTON_SKIP": "mxButtonSkip",
    "BUTTON_STOP": "mxButtonStop",
    "BUTTON_STOP_AUTOSTART": "mxButtonStopAutostart",
    "BUTTON_SKIP_AUTOSTART": "mxButtonSkipAutostart",
    "BUTTON_STOP_BONUS_WHEEL": "mxButtonStopBonusWheel",
    "BUTTON_PREINFO_CLOSE": "mxButtonPreinfoClose",
    "BUTTON_RESPONSIBLE_GAMING": "mxInfoBoxResponsibleGaming",

    "WRAPPER": "wrapper",
    "CONTAINER": "container",

    "GAME_WRAPPER": "gameWrapper",
    "GAME_CONTROLS_WRAPPER": "gameControlsWrapper",
    "GAME_BUTTONS_CONTAINER": "mxGameButtonsContainer",

    "GAME_CANVAS": "gameCanvas",

    "WINTABLE_WRAPPER": "wintableWrapper",
    "WINTABLE_CONTROLS_WRAPPER": "wintableControlsWrapper",
    "WINTABLE_BUTTONS_CONTAINER": "mxWintableButtonsContainer",

    "IFRAME_PARAGRAPH": "mxParagraphIframe",

    "LOADING": "mxLoading",
    "LOADING_CONTAINER": "mxLoadingContainer",

    "MESSAGES": "mxMessages",

    "INFO_BOX_CONTAINER": "mxInfoBoxContainer",
    "INFO_BOX_WARNING": "mxInfoBoxWarning",
    "INFO_BOX_BALANCE": "mxInfoBoxBalance",
    "INFO_BOX_BALANCE_IMAGE": "mxInfoBoxBalanceImage",
    "INFO_BOX_BALANCE_VALUE": "mxInfoBoxBalanceValue",
    "INFO_BOX_GAME_NAME": "mxInfoBoxGameName",

    "AJAX_LOADING_CONTAINER": "mxAjaxLoadingContainer",

    "TIME": "mxBarTime",
};

@injectable()
export default abstract class BaseDOM implements IDOM {

    protected config: SystemConfig;
    protected gameset: any;

    public uiMessages: IUIMessages;
    public bg: BgLayer;
    protected wallet: Wallet;
    protected game: IGame;

    protected wrapper: HTMLElement;
    protected container: HTMLElement;
    protected gameWrapper: HTMLElement;
    protected wintableWrapper: HTMLElement;

    protected gameControlsWrapper: HTMLElement;
    public wintableControlsWrapper: HTMLElement;
    protected wintableButtonsContainer: HTMLElement;

    public spinBtns: Record<string, HTMLElement> = {};

    public ajaxLoading: AjaxLoading | AjaxLoadingNew;

    protected constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.UIMessages) uiMessages: IUIMessages,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.Game) game: IGame
    ) {
        this.config = config;
        this.gameset = config.gameset;
        this.uiMessages = uiMessages;
        this.wallet = wallet;
        this.game = game;

        createjs.MotionGuidePlugin.install();
    }

    getCssStyles() {}

    getSprites() {}

	createDOM() {
        this.wrapper = document.createElement("div");
        this.wrapper.id = BASE_ELEMENT_IDS.WRAPPER;
        this.wrapper.classList.add("mx-wrapper");

        this.wrapper.addEventListener("touchmove", event => {
            event.preventDefault();
        }, false);

        let lastTouchEnd = 0;
        document.addEventListener('touchend', event => {

            if(!isIOS()) {
                return;
            }

            let now = (new Date()).getTime();
            if (now - lastTouchEnd <= 300) {

                let element = event.target;
                let action = $(element).data("action");
                let data = $(element).data("data");

                userActionInstance.trigger(action, data);
                event.preventDefault();
            }
            lastTouchEnd = now;
        }, false);

        // document.addEventListener('touchmove', this._disableZoom, false);

        // let passiveOption = supportsPassiveOption();
        // let option = passiveOption ? { passive : false } : false;

        // window.addEventListener('touchend', this._disableZoom, option);
        // document.addEventListener('touchend', this._disableZoom, option);
        // document.addEventListener('touchmove', this._disableZoom, option);
        // document.addEventListener('gesturestart', this._disableZoom, option);

        // window.addEventListener('touchmove', () => {
        //
        //     let zoom = window.innerWidth / window.document.documentElement.clientWidth;
        //     console.log(zoom);
        //
        // }, supportsPassiveOption ? { passive : false } : false);

        document.body.appendChild(this.wrapper);

        this.container = document.createElement("div");
        this.container.id = BASE_ELEMENT_IDS.CONTAINER;
        this.container.classList.add("mx-container");
        this.wrapper.appendChild(this.container);

        this.gameWrapper = document.createElement("div");
        this.gameWrapper.id = BASE_ELEMENT_IDS.GAME_WRAPPER;
        this.gameWrapper.classList.add("mx-canvas-wrapper");
        this.container.appendChild(this.gameWrapper);

        this.gameControlsWrapper = document.createElement("div");
        this.gameControlsWrapper.id = BASE_ELEMENT_IDS.GAME_CONTROLS_WRAPPER;
        this.gameControlsWrapper.classList.add("mx-controls-wrapper");
        this.container.appendChild(this.gameControlsWrapper);

        const isBellot = this.config.get(CONFIG_PARAMS.BRAND_NAME) === 'bellot';

		this.ajaxLoading = isBellot ? new AjaxLoadingNew() : new AjaxLoading()
        this.ajaxLoading.create(this.gameWrapper);

        this.wintableControlsWrapper = document.createElement("div");
        this.wintableControlsWrapper.id = BASE_ELEMENT_IDS.WINTABLE_CONTROLS_WRAPPER;
        this.wintableControlsWrapper.classList.add("mx-controls-wrapper");
        this.container.appendChild(this.wintableControlsWrapper);

        this.wintableButtonsContainer = document.createElement("div");
        this.wintableButtonsContainer.id = BASE_ELEMENT_IDS.WINTABLE_BUTTONS_CONTAINER;
        this.wintableButtonsContainer.classList.add("mx-buttons-container");
        this.wintableControlsWrapper.appendChild(this.wintableButtonsContainer);

        let loading = document.createElement("div");
        loading.id = BASE_ELEMENT_IDS.LOADING;
        loading.classList.add("mx-loading-wrapper");
        this.wrapper.appendChild(loading);

        this.uiMessages.create(this.wrapper);

        this.wintableWrapper = document.createElement("div");
        this.wintableWrapper.id = BASE_ELEMENT_IDS.WINTABLE_WRAPPER;
        this.wintableWrapper.classList.add("mx-canvas-wrapper");
        $(this.wintableWrapper).insertAfter($(this.gameWrapper));
        $(this.wintableWrapper).hide();

    }

    init() {
        initDOM(this.wallet, this.config, this.wrapper);
    }

    getFontPreloaderWrapper(): HTMLElement {
        return document.getElementById(BASE_ELEMENT_IDS.GAME_WRAPPER);
    }

    getWrapper(): HTMLElement {
        return document.getElementById(BASE_ELEMENT_IDS.WRAPPER);
    }

    getContainer(): HTMLElement {
        return document.getElementById(BASE_ELEMENT_IDS.CONTAINER);
    }

    getMxLoading(): HTMLElement {
        return document.getElementById(BASE_ELEMENT_IDS.LOADING);
    }

    getControlsWrapper(): HTMLElement {
        return document.getElementById(BASE_ELEMENT_IDS.GAME_CONTROLS_WRAPPER);
    }

    getGameWrapper(): HTMLElement {
        return document.getElementById(BASE_ELEMENT_IDS.GAME_WRAPPER);
    }

    getWintableWrapper(): HTMLElement {
        return document.getElementById(BASE_ELEMENT_IDS.WINTABLE_WRAPPER)
    }

    onSetState() {
        let wrapper = document.getElementById(BASE_ELEMENT_IDS.WRAPPER);

        if(this.game.autostart?.isAutostart()) {
            wrapper.classList.add("game-autostart");
            this.game.autostart?.isInfinity() ? wrapper.classList.add("game-autostart-inf") : wrapper.classList.remove("game-autostart-inf");
        } else {
            wrapper.classList.remove("game-autostart", "game-autostart-inf");
        }
    }

    private _disableZoom(event) {
        let zoom = window.innerWidth / window.document.documentElement.clientWidth;
        if(zoom !== 1 || event.scale !== 1) {
            event.preventDefault();
        }
    }

    public showSpinBtn(name: string, enabled = true) {
        this.hideSpinBtn();
        $(this.spinBtns[name]).show();
        $(this.spinBtns[name]).prop("disabled", !enabled);
    }

    public hideSpinBtn() {
        for(let btnName in this.spinBtns) {
            let btn = this.spinBtns[btnName];
            $(btn).hide();
        }
    }

    public abstract showFreeSpins();

    public abstract hideFreeSpins();

    highlightWin() {
    }

    resetWin() {
    }
}

export function getTranslationName(name: string, gameset) {

    switch (name) {
        case "line":
            return gameset.lineGameType && gameset.lineGameType == "levels" ? "level" : name;
        case "bet_line":
            return gameset.lineGameType && gameset.lineGameType == "levels" ? "bet_level" : name;
    }
}

export function createBackground() {
    let bg = document.createElement("div");
    bg.classList.add("mx-bg-layer");
    bg.id = "mxBgLayer";

    return {
        element: bg,
        showBg: () => {
            $(bg).show();
            $(bg).css("opacity", 1);
        },
        hideBg: () => {
            $(bg).css("opacity", 0);
            setTimeout(() => $(bg).hide(), 250)
        }
    }
}

export function createButton({id = "", classes = [], action = "", parent = null}): HTMLElement {
    let btn = document.createElement("button");
    btn.classList.add(...classes);
    if(id) btn.id = id;
    if(parent) parent.appendChild(btn);
    if(action) $(btn).data("action", action);
    return btn;
}

export function insertAfter(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}

export function insertBefore(el, referenceNode) {
    referenceNode.parentNode.insertBefore(el, referenceNode);
}
